import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ContractModel } from "src/app/global/contract-filter-model";
import { FilterSet } from "src/app/global/filter-model";

@Injectable({
  providedIn: 'root'
})
export class FiltersStore {
  // TODO: Move other filters-related global state to this store as needed.
  // OneCustomer name for 1C Integration
  private readonly _oneCustomerName = new BehaviorSubject<string>('');
  private readonly _selectedFilters = new BehaviorSubject<ContractModel | undefined>(undefined);
  private readonly _filterSet = new BehaviorSubject<FilterSet | undefined>(undefined);
  readonly oneCustomerName$ = this._oneCustomerName.asObservable();
  readonly selectedFilters$ = this._selectedFilters.asObservable();
  readonly filterSet$ = this._filterSet.asObservable();

  get oneCustomerNameObservable() {
    return this.oneCustomerName$;
  }

  get selectedFiltersObservable() {
    return this.selectedFilters$;
  }

  get oneCustomerNameValue(): string {
    return this._oneCustomerName.value;
  }

  get selectedFiltersValue(): ContractModel | undefined {
    return this._selectedFilters.value;
  }

  get filterSetValue(): FilterSet | undefined {
    return this._filterSet.value;
  }

  setOneCustomerName(name: string): void {
    this._oneCustomerName.next(name);
  }

  setSelectedFilters(filters: ContractModel | undefined): void {
    this._selectedFilters.next(filters);
  }

  setFilterSet(filterSet: FilterSet | undefined): void {
    this._filterSet.next(filterSet);
  }

  clearOneCustomerName(): void {
    this._oneCustomerName.next('');
  }
}
